import { render } from "./Add_response.vue?vue&type=template&id=8d560312"
import script from "./Add_response.vue?vue&type=script&lang=js"
export * from "./Add_response.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__